import { render, staticRenderFns } from "./LinkSummary.vue?vue&type=template&id=197a232a&scoped=true"
import script from "./LinkSummary.vue?vue&type=script&lang=js"
export * from "./LinkSummary.vue?vue&type=script&lang=js"
import style0 from "./LinkSummary.vue?vue&type=style&index=0&id=197a232a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a232a",
  null
  
)

export default component.exports